var _circle, _path, _g, _path2, _path3, _circle2, _circle3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceWithCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 257,
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128.5,
    r: 104,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1501_22528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 206,
    height: 207
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231 128.5C231 185.385 184.885 231.5 128 231.5C71.1147 231.5 25 185.385 25 128.5V25.5H128H231V128.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1501_22528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 232.5H196C202.627 232.5 208 227.127 208 220.5V85.4706C208 82.288 206.736 79.2357 204.485 76.9853L171.515 44.0147C169.264 41.7643 166.212 40.5 163.029 40.5H60C53.3726 40.5 48 45.8726 48 52.5V220.5C48 227.127 53.3726 232.5 60 232.5Z",
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 64.5,
    width: 68,
    height: 8,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 80.5,
    width: 68,
    height: 8,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 96.5,
    width: 34,
    height: 8,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 168.5V148.5M72 168.5V188.5M72 168.5H184M72 148.5V136.5C72 132.082 75.5817 128.5 80 128.5H176C180.418 128.5 184 132.082 184 136.5V148.5M72 148.5H184M72 188.5V200.5C72 204.918 75.5817 208.5 80 208.5H176C180.418 208.5 184 204.918 184 200.5V188.5M72 188.5H184M184 188.5V168.5M184 168.5V148.5",
    stroke: "#EEEEF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.456 76.9851L171.485 44.0145C169.465 41.994 166.798 40.7684 163.97 40.5391V80.4998C163.97 82.7089 165.761 84.4998 167.97 84.4998H207.931C207.702 81.6725 206.476 79.0056 204.456 76.9851Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.227 14.9854C184.137 14.793 183.863 14.793 183.773 14.9854L182.766 17.1448C182.741 17.198 182.698 17.2408 182.645 17.2657L180.485 18.2735C180.293 18.3632 180.293 18.6368 180.485 18.7265L182.645 19.7343C182.698 19.7592 182.741 19.802 182.766 19.8552L183.773 22.0146C183.863 22.207 184.137 22.207 184.227 22.0146L185.234 19.8552C185.259 19.802 185.302 19.7592 185.355 19.7343L187.515 18.7265C187.707 18.6368 187.707 18.3632 187.515 18.2735L185.355 17.2657C185.302 17.2408 185.259 17.198 185.234 17.1448L184.227 14.9854Z",
    fill: "white",
    stroke: "#92929E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.227 24.9854C168.137 24.793 167.863 24.793 167.773 24.9854L166.129 28.5084C166.104 28.5617 166.062 28.6044 166.008 28.6293L162.485 30.2735C162.293 30.3632 162.293 30.6368 162.485 30.7265L166.008 32.3707C166.062 32.3956 166.104 32.4383 166.129 32.4916L167.773 36.0146C167.863 36.207 168.137 36.207 168.227 36.0146L169.871 32.4916C169.896 32.4383 169.938 32.3956 169.992 32.3707L173.515 30.7265C173.707 30.6368 173.707 30.3632 173.515 30.2735L169.992 28.6293C169.938 28.6044 169.896 28.5617 169.871 28.5084L168.227 24.9854Z",
    fill: "white",
    stroke: "#92929E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 104.5,
    r: 28,
    fill: "#F7F7F8",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 104.5,
    r: 20,
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0938 94.4417C33.4529 93.6722 34.5471 93.6722 34.9062 94.4416L37.6646 100.352C37.7639 100.565 37.935 100.736 38.1479 100.835L44.0583 103.594C44.8278 103.953 44.8278 105.047 44.0583 105.406L38.1479 108.165C37.935 108.264 37.7639 108.435 37.6646 108.648L34.9062 114.558C34.5471 115.328 33.4529 115.328 33.0938 114.558L30.3354 108.648C30.2361 108.435 30.065 108.264 29.8521 108.165L23.9417 105.406C23.1722 105.047 23.1722 103.953 23.9416 103.594L29.8521 100.835C30.065 100.736 30.2361 100.565 30.3354 100.352L33.0938 94.4417Z",
    fill: "white",
    stroke: "#92929E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 111.5,
    width: 88,
    height: 112,
    rx: 8,
    fill: "white",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 119.5,
    width: 72,
    height: 32,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 127.5,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 127.5,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 127.5,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 159.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 175,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 190.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 206,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 159.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 175,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 190.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 206,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 159.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 175,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 190.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 206,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 201.5,
    y: 159.5,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 201.5,
    y: 175,
    width: 13.5,
    height: 9.5,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 190.5,
    width: 13,
    height: 25,
    rx: 3,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceWithCalculator);
export default __webpack_public_path__ + "static/media/invoice-with-calculator.4a970d0bea1373ad0186cf2d6c6b11d0.svg";
export { ForwardRef as ReactComponent };